import { render, staticRenderFns } from "./AddWidget.vue?vue&type=template&id=4bee7170&scoped=true"
import script from "./AddWidget.vue?vue&type=script&lang=js"
export * from "./AddWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee7170",
  null
  
)

export default component.exports